import translate from '../tools/translate';

const Factory = (type, area) => {
    const constructor = types[type] || types.default;
    return constructor(area);
};

Factory.getAvailableOptions = () => {
    const options = [];

    options.push({ value: 'copy', text: translate('Common.CopyOrigin') });
    options.push({ value: 'copyNot', text: translate('Common.NotCopyOrigin') });

    return options;
};

export default Factory;



// WEBPACK FOOTER //
// ./src/scripts/core/selection/ConfigurationMap.js